//
// ***** DO NOT INSTANTIATE THIS CLASS DIRECTLY *****
//
import { autoinject } from 'aurelia-framework';
import { ServiceResponse } from '../models/service-response';

@autoinject
export class BaseService {

	constructor() {}

	protected success(successMessage: string = '', value: any = null): Promise<ServiceResponse> {
		return new Promise<ServiceResponse>((resolve) => {
			resolve(new ServiceResponse({ isSuccessful: true, resultMessage: successMessage, value }));
		});
	}

	protected error(errorMessage: string = ''): Promise<ServiceResponse> {
		return new Promise<ServiceResponse>((resolve) => {
			resolve(new ServiceResponse({ isSuccessful: false, resultMessage: errorMessage, value: null }));
		});
	}
}
